import React from 'react';

import './TextShowcaseGroup.scss';

interface ITextShowcaseGroupProps {
  children?: React.ReactNode;
  isReverse?: boolean;
  areSizesReverse?: boolean;
  areItemsCentered?: boolean;
}

export function TextShowcaseGroup({ children, isReverse, areSizesReverse, areItemsCentered }: ITextShowcaseGroupProps) {
  const childrenArray = React.Children.toArray(children);

  const child1 = childrenArray && childrenArray.length > 0
    ? childrenArray[0] : null;
  const child2 = childrenArray && childrenArray.length > 1
    ? childrenArray[1] : null;

  return (
    <div className={ `TextShowcaseGroup ${ isReverse ? 'TextShowcaseGroup--reverse' : '' } ${ areItemsCentered ? 'TextShowcaseGroup--centered' : '' }` }>
      <div className={ areSizesReverse ? 'TextShowcaseGroup__item--bigger' : 'TextShowcaseGroup__item--smaller' }>
        { child1 }        
      </div>
      <div className={ areSizesReverse ? 'TextShowcaseGroup__item--smaller' : 'TextShowcaseGroup__item--bigger' }>
        { child2 }
      </div>
    </div>
  );
}
